import { PrimaryButton } from 'components/button';
import { SendButton2 } from 'containers/pages/free-course/components/questions/styled';
import styled from 'styled-components';
import { mediaSm, mediaXs } from 'theme/theme-helper-selectors';

export const Content = styled.div`
    padding-top: 100px;
    @media (${mediaXs}) {
        padding-top: 48px;
    }
`;
export const TitleBlock = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    @media (${mediaXs}) {
        flex-wrap: wrap;
    }
`;
export const Title = styled.h2`
    font-size: 72px;
    font-weight: 400;
    line-height: 74px;
    margin: 0 0 40px;
    text-align: left;
    @media (${mediaSm}) {
        font-size: 42px;
        line-height: 44px;
    }
    @media (${mediaXs}) {
        font-size: 24px;
        font-weight: 500;
        line-height: 27px;
        max-width: 250px;
    }
`;
export const ButtonsBlock = styled.div`
    display: flex;
    flex-direction: row;
    gap: 16px;
    @media (${mediaXs}) {
        margin-bottom: 0px;
    }
`;

export const ManageButton = styled(PrimaryButton)`
    background: ${({ theme }) => theme.palette.gray[600]};
    padding: 14px;
    border-radius: 50%;
    z-index: 2;
`;

export const PublicationContent = styled.div<{
    bgImage: string;
    bgImageMobile?: string;
}>`
    background-position: bottom;
    border-radius: 40px;
    display: flex;
    flex-direction: column;
    height: 768px;
    justify-content: space-between;
    padding: 64px 60px;
    background-image: url(${({ bgImage }) => bgImage});
    background-size: cover;
    z-index: 1;
    width: 100%;

    @media (${mediaSm}) {
        height: 66.6666666667vw;
        padding: 32px;
    }

    @media (${mediaXs}) {
        height: auto;
        min-height: 300px;
        padding: 16px;
        background-image: ${({ bgImageMobile, bgImage }) =>
            `url(${bgImageMobile || bgImage})`};
    }

    @media (max-width: 470px) {
        height: auto;
    }
`;

export const DescriptionPublication = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    gap: 15px;
`;
export const PublicationTagsBlock = styled.ul`
    display: flex;
    flex-direction: row;
    list-style: none;
    margin: 0 0 16px;
    padding: 0;
`;

export const PublicationTag = styled.li`
    background-color: #fff;
    border-radius: 24px;
    display: inline;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0.12em;
    line-height: 14px;
    margin: 0 0px;
    padding: 5px 16px;
    text-align: left;
    text-transform: uppercase;
`;

export const PublicationDescription = styled.p`
    color: #fff;
    font-size: 24px;
    font-weight: 300;
    line-height: 27px;
    margin-bottom: 32px;
    max-width: 480px;
    text-align: left;
    @media (${mediaSm}) {
        font-size: 20px;
        line-height: 22px;
        margin-bottom: 16px;
    }
    @media (${mediaXs}) {
        font-size: 16px;
        line-height: 18px;
        margin-bottom: 8px;
    }
`;

export const DownloadLink = styled(SendButton2)`
    background: ${({ theme }) => theme.palette.teal};
    border-radius: 8px;
    padding: 20px 24px;
    font-size: 21px;
    line-height: 24px;
    font-weight: 500;
    display: flex;
    gap: 6px;
    cursor: pointer;
`;

export const PublicationBottomBlock = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;

export const PublicationBottomTitle = styled.h3<{
    $showLargeTitleOnMobile?: boolean;
}>`
    color: ${({ theme }) => theme.palette.white};
    font-size: 52px;
    font-weight: 400;
    line-height: 52px;
    text-align: left;
    span {
        color: ${({ theme }) => theme.palette.teal};
    }

    @media (${mediaSm}) {
        font-size: 32px;
        line-height: 34px;
    }
    @media (${mediaXs}) {
        display: ${({ $showLargeTitleOnMobile }) =>
            $showLargeTitleOnMobile ? 'block' : 'none'};
        font-size: ${({ $showLargeTitleOnMobile }) =>
            $showLargeTitleOnMobile ? '28px' : '18px'};
        line-height: ${({ $showLargeTitleOnMobile }) =>
            $showLargeTitleOnMobile ? '30px' : '20px'};
    }
`;

export const PublicationBottomTime = styled.p`
    color: hsla(0, 0%, 100%, 0.6);
    font-size: 24px;
    font-weight: 300;
    line-height: 24px;
    margin-top: auto;
    min-width: 160px;
    text-align: left;
    @media (${mediaSm}) {
        font-size: 16px;
        line-height: 18px;
        min-width: 100px;
    }
    @media (${mediaXs}) {
        font-size: 12px;
        line-height: 14px;
        min-width: 70px;
    }
`;
